module.exports = __webpack_public_path__ + "static/media/clipboard-list.ce00677b.svg";